import { render } from "./Dashboard0.vue?vue&type=template&id=ebdc10ee"
import script from "./Dashboard0.vue?vue&type=script&lang=js"
export * from "./Dashboard0.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__